export default __webpack_public_path__ + "static/media/au_hrct.0677a063.jpg";